import { SbbLoadingIndicatorCircle } from "@sbb-esta/lyne-react/loading-indicator-circle";
import { BoardLookup } from "models/BoardLookup";
import { SendToTargetModel } from "models/SendToTargetModel";
import { useTranslations } from "providers";
import React from "react";

export interface SendToTableProps {
  items: SendToTargetModel[];
  getDisplayBoard: (item: SendToTargetModel) => BoardLookup | undefined;
  deletingId: number | null;
  onRemove: (id: number) => void;
}

export const SendToTable: React.FC<SendToTableProps> = ({ items, getDisplayBoard, deletingId, onRemove }) => {
  const i18n = useTranslations();

  return (
    <table className="table table-sm sbb-table-bs table-hover mb-0">
      <thead>
        <tr>
          <th>{i18n.Board}</th>
          <th className="actions">{i18n.Actions}</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => {
          const board = getDisplayBoard(item);
          const displayName = board?.longName || board?.name || "-";
          return (
            <tr key={item.id}>
              <td>{displayName}</td>
              <td className="actions w-auto text-nowrap">
                {item.canDelete && (
                  <button
                    type="button"
                    className="btn btn-link btn-sm text-danger"
                    disabled={deletingId === item.id}
                    onClick={() => onRemove(item.id)}
                  >
                    {deletingId === item.id ? <SbbLoadingIndicatorCircle /> : <i className="ms-Icon ms-Icon--Delete" />}{" "}
                    {i18n.Actions_Delete}
                  </button>
                )}
              </td>
            </tr>
          );
        })}
        {items.length === 0 && (
          <tr>
            <td colSpan={2} className="text-muted">
              {i18n.EmptyTable}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
